import React from "react";
import { Link } from "react-router-dom";


const CallToAction = () => {
  return (
    <div className="w-full bg-red-200 py-10 text-center">
      <div className="max-w-7xl w-11/12 mx-auto text-md space-y-3">
        <h2 className="md:text-3xl text-2xl font-bold">Let's Stay In Touch</h2>
        <p>Find best recipes for cooking</p>
       <Link to="/recipes">
        <button id="load-more" aria-label="load-more" className="p-2 mt-2 rounded-md  bg-white" >
          View More Recipes
        </button>
        </Link>
      </div>
    </div>
  );
};

export default CallToAction;
